<template>
  <div class="data-management-block">
    <vx-card title="Data Management" class="mb-6">
      <vs-list>
        <vs-list-item title="Delete visits & contacts" class="block md:flex">
          <div class="flex w-full md:min-w-sm mt-2 md:mt-0">
            <v-select
              label="name"
              class="min-w-48"
              placeholder="Contact Type"
              :options="contactTypes.items || []"
              v-model="form.typeId"
              :reduce="option => option.id"
              :clearable="true" />
            <v-select :options="ageOptions" class="w-full ml-2" v-model="form.age" :reduce="option => option.age" :clearable="false" />
          </div>
        </vs-list-item>
      </vs-list>
      <div class="px-3 flex justify-end">
        <vs-button type="border" color="danger" @click="activePrompt = true">Delete</vs-button>
      </div>
    </vx-card>
    
    <vs-prompt
      @accept="deleteData"
      @cancel="closePrompt"
      @close="closePrompt"
      :active="activePrompt"
      title="Confirm Delete"
      acceptText="Delete"
      color="danger">
      <p>Are you sure you want to <span class="font-semibold">DELETE ALL VISITS AND CONTACTS </span><span v-if="form.typeId">{{ selectedType }}</span>{{ selectedAge }}?</p>
      <vx-field
        type="input"
        class="w-full mt-4"
        label="Please type 'DELETE' to confirm"
        as="confirm delete"
        v-model="confirmDelete"
        v-validate="{
          required: true,
          is: 'DELETE'
        }"
      />
    </vs-prompt>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import vSelect from 'vue-select';
export default {
  data: () => ({
    form: {
      age: 30,
      typeId: undefined
    },
    confirmDelete: '',
    activePrompt: false,
    ageOptions: [
      {
        age: 30,
        label: 'Older than 30 days'
      }, {
        age: 60,
        label: 'Older than 60 days'
      }, {
        age: 120,
        label: 'Older than 120 days'
      }, {
        age: 365,
        label: 'Older than 365 days'
      }
    ]
  }),
  computed: {
    ...mapState('visitManagement', ['contactTypes']),
    selectedAge () {
      return this.ageOptions.find(item => item.age === this.form.age).label
    },
    selectedType () {
      const type = this.contactTypes.items.find(item => item.id === this.form.typeId);
      return type ? ` with '${type.name}' contact type and ` : ''
    }
  },
  methods: {
    deleteData () {
      this.$validator.validateAll().then(async valid => {
        if (valid) {
          const result = await this.$store.dispatch('visitManagement/deleteManagementData', this.form)
          if (result.success) this.closePrompt();
        }
      });
    },
    closePrompt () {
      this.confirmDelete = '';
      this.activePrompt = false;
    }
  },
  mounted () { },
  components: {
    vSelect
  }
}
</script>